import React from 'react';
import _ from 'lodash';
import { Box, Grid, Typography, Divider as MuiDivider } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { withShowable } from '../../../_global/lib/withShowable';

const Divider = withShowable(MuiDivider);

const SummaryAdditionalInsured = ({ AI }: any) => {
  const classes = useStyles();

  if (!AI || !AI.length) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <Box className={classes.subHeader}>
        <Typography className={classes.subHeaderTitle}>
          Additional Insured
        </Typography>
      </Box>

      {AI.map((insured: any, index: any) => {
        return (
          <>
            <Grid
              container
              spacing={6}
              className={classes.AI}
              justifyContent="space-between"
            >
              <Grid item md={3}>
                Additional Insured {index + 1}
              </Grid>
              <Grid
                item
                md={9}
                container
                spacing={6}
                style={{ paddingLeft: '3rem', paddingBottom: '3rem' }}
              >
                <Grid item md={3}>
                  <Grid>Organization Name:</Grid>
                  <Grid style={{ padding: '1rem 0' }}>Address:</Grid>
                  <Grid>Industry Code:</Grid>
                </Grid>
                <Grid item md={5}>
                  <Grid>{insured.businessName}</Grid>
                  <Grid style={{ padding: '1rem 0' }}>
                    {_.join(
                      [
                        [insured.address1, insured.address2].join(' '),
                        [insured.city],
                        [insured.state, insured.zipCode].join(' '),
                      ],
                      ', '
                    )}
                  </Grid>
                  <Grid>
                    {insured.naicsCode}: {insured.naicsDescription}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Divider
              className={classes.AiDivider}
              show={index !== AI.length - 1}
            />
          </>
        );
      })}
    </Grid>
  );
};

const useStyles = makeStyles(({ palette, config }) => ({
  AiDivider: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  AI: {
    fontWeight: 'normal',
    padding: '0 2rem',
    fontSize: config.textSizes.primer,
    color: palette.primary.contrastText,
  },
  subHeader: {
    display: 'flex',
    padding: '0.5em 2em',
    backgroundColor: palette.background.customTable,
    borderRadius: 5,
    lineHeight: 1.4,
    margin: '1.66rem 0',
  },
  subHeaderTitle: {
    color: palette.primary.contrastText,
    fontSize: config.textSizes.paragon,
    fontWeight: 'normal',
    lineHeight: 1.4,
  },
}));

export default SummaryAdditionalInsured;
